/**
 * Route-aware Clarity pause/stop for token-bearing and heavy-viewer paths.
 * Mounted inside the data router so useLocation is available.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { syncClarityForPath } from './clarity';

/**
 * Syncs Clarity recorder state to the current pathname.
 */
export function MonitoringRouteEffects(): null {
  const location = useLocation();

  useEffect(() => {
    // Pause on auth-token URLs and DXF/PDF viewers, resume elsewhere. Runs even when
    // Clarity is not yet started — syncClarityForPath owns the deferred-start retry
    // for sessions that landed on a token-bearing URL.
    syncClarityForPath(location.pathname);
  }, [location.pathname]);

  return null;
}
